export default __webpack_public_path__ + "static/media/logo.33d36250.svg";